export default "__VITE_ASSET__Bl390bmK__"